import LacunaWebPKI from 'web-pki';
import { ReactComponent as ErrorIcon } from '../../../assets/images/icons/mevo/error.svg';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';

interface DialogRedirectToInstallWebPKIProps {
  onGoBack(): void;
}

export function DialogRedirectToInstallWebPKI(props: DialogRedirectToInstallWebPKIProps) {
  const redirectToWebPKI = () => {
    const pki = new LacunaWebPKI();

    pki.redirectToInstallPage();
  };
  return (
    <Flex alignItems={'center'} justifyContent={'center'} flexDir={'column'}>
      <ErrorIcon />

      <Flex mt={'20px'} flexDir={'column'} gap={'10px'}>
        <Text fontSize={'18px'} fontWeight={700} lineHeight={'18px'} textAlign={'center'} mb={'10px'}>
          Instale a Extensão WebPKI para Emissão da Receita Digital
        </Text>
        <Text fontSize={'14px'} fontWeight={400} lineHeight={'18px'} textAlign={'center'} mb={'10px'}>
          Instale a WebPKI no seu navegador para garantir o acesso aos seus certificados e facilitar o processo de
          emissão.
        </Text>

        <Flex w={'100%'} gap={'10px'}>
          <Button onClick={props.onGoBack} variant={'outline'} w={'100%'}>
            Voltar
          </Button>
          <Button onClick={redirectToWebPKI} w={'100%'}>
            Instalar
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
